__turbopack_context__.v({
  "captchaBadge": "EmailTripDialog-module__tejCwq__captchaBadge",
  "footer": "EmailTripDialog-module__tejCwq__footer",
  "form": "EmailTripDialog-module__tejCwq__form",
  "marketingCopy": "EmailTripDialog-module__tejCwq__marketingCopy",
  "privacy": "EmailTripDialog-module__tejCwq__privacy",
});
